"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
function default_1() {
    const { t } = (0, react_i18next_1.useTranslation)();
    return (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "body1 gray-80" }, { children: t('[배송대행업체]에 작품이 도착한 사진') }));
}
exports.default = default_1;
